<template>
  <b-form-group label="Instituto Selecionado" label-for="instituto">
    <b-form-select
      id="instituto"
      value-field="id"
      text-field="nome"
      @change="alterarInstituto"
      v-model="dados.institutoId"
      :options="instituto"
      :disabled="isBusy"
    >
    </b-form-select>
  </b-form-group>
</template>
<script>
import { BFormSelect, BRow, BCol, BFormGroup } from 'bootstrap-vue';
import useJwt from '@/auth/jwt/useJwt';
import { sortAlphabetical } from '@/libs/utils.js';
import { mapGetters } from 'vuex';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { checkPermission } from '@/libs/checkPermission.js';
import { useLoadingStore } from '@/store/pinia/loadingStore';

export default {
  components: {
    BFormSelect,
    BRow,
    BCol,
    BFormGroup,
    checkPermission,
  },
  computed: {
    ...mapGetters({
      userData: 'user/userData',
    }),
  },
  data() {
    return {
      isBusy: false,
      sortAlphabetical,
      dados: {},
      instituto: [],
    };
  },
  mounted() {
    if (this.userData.institutoSelecionado != undefined)
      this.carregarInstituto(this.userData.institutoSelecionado);

    this.$root.$on('selecionarInstitutoNavBar', institutoId => {
      if (institutoId) {
        this.carregarInstituto(institutoId);
      }
    });
  },
  methods: {
    async carregarInstituto(item) {
      this.dados.institutoId = item;

      if (
        this.userData.role != 'master' &&
        this.userData.institutoId.length > 0
      ) {
        this.instituto = sortAlphabetical(this.userData.instituto);
        this.instituto.map(inst => {
          inst.nome = inst.nome.toUpperCase();
        });
        return;
      } else {
        await useJwt
          .get('institutos/basics')
          .then(response => {
            response.data.map(inst => {
              inst.nome = inst.nome.toUpperCase();
            });
            this.instituto = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    async getData(method, url, params) {
      let response = await useJwt[`${method}`](url, params).catch(error => {
        console.log('[getData]', error);
      });
      return response.data;
    },
    async alterarInstituto(item) {
      this.isBusy = true;
      const loadingStore = useLoadingStore();
      loadingStore.setLoadingRoute(true);
      this.$root.$emit('hideMenuItens');

      try {
        const institutoSelected = await this.getData(
          'get',
          `institutos/${this.dados.institutoId}`
        );
        const grupoAcesso = await this.getData('post', `institutos/getGrupo`, {
          idInstitudoId: this.dados.institutoId,
          grupoAcessoId: this.userData.grupoAcessoId,
        });

        if (
          this.userData.role != 'master' &&
          grupoAcesso.controlaAcesso &&
          grupoAcesso?.ExpedienteAcesso?.length > 0
        ) {
          const check = checkPermission(grupoAcesso?.ExpedienteAcesso);
          if (!check) {
            this.msgAlert('Você não tem permissão de acesso neste horário!');
            this.logout();
            return;
          }
        }

        await useJwt.post(`utils/createLogAcesso/${this.dados.institutoId}`, {
          ip: this.userData.ip,
          email: this.userData.email,
          userAgent: this.userData.userAgent,
          userId: this.userData.id,
          userNome: this.userData.name,
        });

        this.$store.commit('user/UPDATE_USER_DATA', {
          ...this.userData,
          grupoAcesso: grupoAcesso,
          institutoLogo: institutoSelected?.logo?.logo,
          institutoSelecionado: item,
          institutoSelecionadoData: institutoSelected,
        });
        this.$router.go();
      } catch (error) {
        console.log('Erro ao alterar instituto', error);
      } finally {
        this.isBusy = false;
        loadingStore.setLoadingRoute(false);
      }
    },
    logout() {
      // makes logout
      useJwt.clearUserLocalStorage();
      this.$router.push({ name: 'auth-login' });
    },
    msgAlert(title) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Atenção',
            icon: 'BellIcon',
            text: title,
            variant: 'danger',
          },
        },
        {
          position: 'top-right',
          timeout: 8000,
        }
      );
    },
  },
};
</script>
